import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter } from '../../../global/commonStyle';

export const MainDiv = styled.div`
  width: 100%;
  border-radius: var(--border-radius-8);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
`;

export const TableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-0);
  border-top-left-radius: var(--border-radius-8);
  border-top-right-radius: var(--border-radius-8);
  ${mobile_xl(css`
    overflow: hidden;
  `)}
`;

export const TableRow = styled.div`
  ${AlignCenter}
  padding: var(--space-12) var(--space-20) var(--space-12) var(--space-11);
  border-bottom: 0.5px solid var(--border-primary);
  &.background-color {
    background-color: var(--background-tertiary);
    border-top-left-radius: var(--border-radius-8);
    border-top-right-radius: var(--border-radius-8);
  }
  &:last-child {
    border-bottom: none;
  }
  ${mobile_xl(css`
    width: 100vw;
    padding-inline: var(--space-12);
  `)}
`;

export const SkeletonCell = styled.div`
  height: 9px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-8);
  margin-block: var(--space-5);
  &.col-1 {
    width: 84px;
    &.header {
      width: 100px;
    }
  }
  &.col-2 {
    width: 80px;
  }
  &.col-3 {
    width: 80px;
  }

  /* Loading animation */
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
    animation: shimmer 1s infinite;
  }
  @keyframes shimmer {
    0% {
      left: -100px;
    }
    100% {
      left: 100px;
    }
  }
`;

export const Div = styled.div`
  max-width: 245px;
  width: 100%;
  &.col-2 {
    max-width: 201px;
    padding-inline: var(--space-11) var(--space-20);
    &.border {
      border-inline: 0.5px solid var(--border-primary);
    }
  }
  &.col-3 {
    max-width: 141px;
    padding-left: var(--space-11);
  }
  ${mobile_xl(css`
    max-width: unset;
    width: 184px;
    &.col-2 {
      max-width: unset;
      width: 201px;
    }
    &.col-3 {
      display: none;
    }
  `)}
`;
